import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { PermissionService } from '@services/index';
import { Permission } from 'app/enums';

@Directive({
    selector: '[appHasPermissions]',
    standalone: false
})
export class HasPermissionsDirective {
    public constructor(
        private templateRef: TemplateRef<unknown>,
        private viewContainer: ViewContainerRef,
        private permissionService: PermissionService
    ) {}

    @Input()
    public set appHasPermissions(permissions: Permission[]) {
        this.checkIfUserHasPermissions(permissions);
    }

    private checkIfUserHasPermissions(permissions: Permission[]): void {
        if (this.permissionService.hasPermissions(permissions)) {
            this.viewContainer.createEmbeddedView(this.templateRef);
        } else {
            this.viewContainer.clear();
        }
    }
}
